<template>

        <div class="leisure_button_group_sub">
            <router-link tag="button" class="bw4"  :class="{'btn_leisure_sub_active':$store.state.currentLeisureGameID === leisureConst.LEISURE_KIND_POWERBALL}"
                         :to="{path:'/leisure/powerball', query: {t: new Date().getTime()}}">파워볼</router-link>

            <router-link tag="button" class="bw4"  :class="{'btn_leisure_sub_active':$store.state.currentLeisureGameID === leisureConst.LEISURE_KIND_POWERSADALI}"
                         :to="{path:'/leisure/powersadali', query: {t: new Date().getTime()}}">파워사다리</router-link>

            <router-link tag="button" class="bw4"  :class="{'btn_leisure_sub_active':$store.state.currentLeisureGameID === leisureConst.LEISURE_KIND_SPEEDKINO}"
                         :to="{path:'/leisure/speedkino', query: {t: new Date().getTime()}}"> 스피드키노</router-link>

            <router-link tag="button" class="bw4"  :class="{'btn_leisure_sub_active':$store.state.currentLeisureGameID === leisureConst.LEISURE_KIND_KINOSADALI}"
                         :to="{path:'/leisure/kinosadali', query: {t: new Date().getTime()}}">키노사다리</router-link>

        </div>


</template>
<script>
    import sportsConst from "../../common/sportsConst";
    import leisureConst from "../../common/leisureConst";

    export default {
        name: "LeisureCompDonghangGameLinks",
        props: {
            comp: {
                type: Number,
                default() {
                    return -1
                }
            },
        },
        data(){
            return {
                leisureConst:leisureConst,
            }
        }
    }
</script>

<style scoped>

</style>